// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

export default function setNumResa(resaInfos){

    return resaInfos.total+"-"+dayjs(resaInfos.created).format("DDMM")+"-"+resaInfos.id_resa;
}